module.exports = __webpack_public_path__ + "img/base_activites_golf.b6cdaa4f.svg";